module.exports = __webpack_public_path__ + "img/vip_only_kr1.99c5d478.png";